"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('module-button', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M14 8H38.4286H50V24H38.4286H14V8Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M22 16H42",
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9469 50C19.4279 42.8771 15.6873 38.7492 14.7251 37.6162C13.2817 35.9168 13.8878 33.996 17.4999 33.996C21.1121 33.996 23.1953 39.2814 25.9469 39.2814C25.9469 39.2814 25.9644 32.5257 25.9502 19.004C25.9485 17.3467 27.2906 16.0017 28.9479 16L28.9511 16C30.6102 16 31.9553 17.345 31.9553 19.0042V31.0136C39.928 32.2224 44.2626 32.8893 44.9589 33.0144C46.0034 33.2019 47.9469 34.199 47.9469 37.068C47.9469 38.9807 48 45.9581 48 56H25.9502L25.9469 50Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("line", {
    x1: "27",
    y1: "50",
    x2: "47",
    y2: "50",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;